import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { getComplianceStandards } from "../store/actions/complianceActions"; // Import action
import { Redirect } from "react-router-dom";
import { LuPlus } from "react-icons/lu";

import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";
import ComplianceCard from "../components/Compliance/ComplianceCard"; // Card component for standards

function ComplianceCards(props) {
    const { token, getComplianceStandardsFN, complianceStandards } = props;

    useEffect(() => {
        getComplianceStandardsFN(); // Fetch compliance standards when component mounts
    }, []);

    //console.log(complianceStandards);

    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full overflow-hidden">
                <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" />
                <div className="flex flex-col w-full p-4 overflow-auto">
                    <div className="flex flex-row">
                        <button
                            className="flex items-center justify-center gap-2 pt-2 pb-2 h-10 text-l bg-[#F8F8F8] text-black transition duration-200 rounded-[5px] px-5 hover:bg-opacity-70 shadow-md border border-gray-300 hover:shadow-lg hover:bg-[#F0F0F2]"
                        >
                            <LuPlus className="ml-[-10px] w-5 h-5" />
                            <span>Add Standard</span>
                        </button>
                    </div>
                    <div className="h-full w-full mt-12 ml-14">
                        
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-0">
                            {complianceStandards?.map((standard) => (
                                <ComplianceCard
                                    key={standard.id} // Adjust key based on your data structure
                                    standard={standard}
                                />
                            ))}
                        </div>
                        <div style={{ height: "20px" }}></div>
                    </div>
                </div>
            </div>
        </div>
    ) : <Redirect to="/login" />;
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        complianceStandards: state.compliance.complianceStandards || [],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getComplianceStandardsFN: () => dispatch(getComplianceStandards()),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceCards);